import _ from 'lodash';
import React from 'react';

import { useTranslation } from '../../../../../custom-hooks/useTranslation';
import ReadOnlyRichText from '../../../../../form-designer/controls/ssTextArea/ssRichTextEditor/ReadOnlyRichText';
import { convertHtmlToRawContentState } from '../../../../../form-designer/utils/controls/ssRichTextEditor.utils';
import { isNilOrEmpty } from '../../../../../utils/ramdaUtils';
import {
  COMPARISON_MESSAGE_ACCESSOR,
  ID_ACCESSOR,
  MESSAGE_ACCESSOR,
} from '../../../../constants/common.constants';

const memoizedHtmlToRawContentState = _.memoize(convertHtmlToRawContentState, _.identity);

const MessageCell = ({ row }) => {
  const translateString = useTranslation();

  const id = row[ID_ACCESSOR];
  const message = translateString(row[MESSAGE_ACCESSOR]);
  const comparisonMessage = translateString(row[COMPARISON_MESSAGE_ACCESSOR]);

  const defaultRawContentState = !isNilOrEmpty(message)
    ? memoizedHtmlToRawContentState(message)
    : null;

  return (
    <div>
      <div>
        {defaultRawContentState ? (
          <ReadOnlyRichText defaultValue={defaultRawContentState} key={id} />
        ) : null}
      </div>
      <div>{comparisonMessage}</div>
    </div>
  );
};

export default MessageCell;
